import { MapPin, Plus, Menu } from "lucide-react";
import { useSidebar } from "@/components/ui/sidebar";

interface OnSiteBarProps {
  onRecordClick: () => void;
}

export function OnSiteBar({ onRecordClick }: OnSiteBarProps) {
  const { setOpenMobile } = useSidebar();

  return (
    <div
      className="fixed top-0 left-0 right-0 z-40 flex items-center justify-between gap-2 px-[var(--page-padding)] pr-3"
      style={{
        background: "linear-gradient(135deg, var(--orb-purple), var(--orb-purple-dark, #5B21B6))",
        height: 56,
        boxShadow: "0 2px 12px rgba(124, 58, 237, 0.25)",
      }}
    >
      {/* Left: hamburger + indicator */}
      <div className="flex items-center gap-1.5 min-w-0">
        <button
          onClick={() => setOpenMobile(true)}
          className="w-10 h-10 flex items-center justify-center shrink-0 rounded-lg text-white opacity-85 active:opacity-100 active:bg-white/[0.12] transition-all"
          aria-label="Open menu"
        >
          <Menu size={20} strokeWidth={2} />
        </button>
        <div className="flex items-center gap-1.5 text-white min-w-0">
          <MapPin size={18} className="shrink-0" style={{ animation: "pin-pulse 2s ease-in-out infinite" }} />
          <span className="text-sm font-semibold tracking-[0.01em] whitespace-nowrap">You're on site</span>
        </div>
      </div>

      {/* Right: CTA */}
      <button
        onClick={onRecordClick}
        className="shrink-0 h-10 min-h-[40px] px-[18px] rounded-[10px] bg-white text-[var(--orb-purple)] text-sm font-bold flex items-center gap-1.5 active:scale-[0.96] active:bg-[var(--orb-purple-light)] transition-all"
      >
        <Plus size={16} strokeWidth={2.5} />
        Record Site Visit
      </button>
    </div>
  );
}
